import { type SVGProps } from "react";

import { cn } from "../../utils";

export interface NcIconProps extends SVGProps<SVGSVGElement> {
  alt?: string;
}

export const NcIcon = ({
  children,
  alt,
  fill = "currentColor",
  className,
  ...props
}: NcIconProps) => {
  const role = alt && alt.length > 0 ? "img" : "presentation";
  const title = alt && alt.length > 0 ? <title>{alt}</title> : <></>;
  return (
    <svg
      data-nc="NcIcon"
      className={cn("inline-block h-[1.1em]", className)}
      fill={fill}
      {...props}
      role={role}
    >
      {title}
      {children}
    </svg>
  );
};
